import { render } from "./LeadHazard.vue?vue&type=template&id=046125d2&scoped=true"
import script from "./LeadHazard.vue?vue&type=script&lang=js"
export * from "./LeadHazard.vue?vue&type=script&lang=js"

import "./LeadHazard.vue?vue&type=style&index=0&id=046125d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046125d2"]])

export default __exports__